// //export const API_SERVER_EXCEL = "http://localhost/amutils";
// export const API_SERVER_EXCEL = "https://ninjahouseware.my/amutils";

// //export const LOCAL_SERVER = "http://localhost/amlifefb";
// export const LOCAL_SERVER = "https://ninjahouseware.my/amlifefb";

// //export const PAYSLIP_SERVER = "http://localhost/user_upl/uploads";
// export const PAYSLIP_SERVER = "https://ninjahouseware.my/user_upl/uploads";

// export const LINECLEAR_AWB_SERVER = "https://uat-app.lineclearexpressonline.com";   //testing server

export const LINECLEAR_AWB_SERVER = "https://app.lineclearexpressonline.com"; // production server

//export const API_BASE_URL = "http://localhost/skycust";
export const API_BASE_URL = "https://myparcel2u.com.my/skycust";
